import React from 'react';

import moment from 'moment';

import { showAlert } from 'components/shared/Alert/Alert';
import DatePicker from 'components/shared/DatePicker/DatePicker';
import Input from 'components/shared/Input/Input';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import Select from 'components/shared/Select/Select';

import {
  endsOptions,
  getWeekOfMonth,
  handleSelectWeekday,
  repeatEventOptions,
  weekdays
} from '../../../EventForm/lib';

import handleChangeEnds from './lib/handleChangeEnds';
import { default as onHandleRepeatAppointment } from './lib/onHandleRepeatAppointment';

const AppointmentRecurrence = ({ formik }) => {
  const { values, setFieldValue } = formik;
  const startDate = values?.starts_at || values?.startsAt;

  const handleChangeRepeatOn = (type) => {
    setFieldValue('repeat_on', values.repeat_on === type ? null : type);
  };
  const handleChangeEndOnDate = (date) => {
    if (moment(date).isAfter(moment(startDate).add(1, 'days'))) {
      setFieldValue('end_date', date);
      return;
    }
    showAlert({
      color: 'warning',
      message: 'End date should be at least one day ahead of the start date.'
    });
  };

  const selectedRepeatEvent = values?.repeat_event;

  const selectedWeekdays = values?.weekdays;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-4">
        <Select
          inputId="repeat-event"
          label="Repeat event"
          value={selectedRepeatEvent}
          options={repeatEventOptions.filter((it) => it.value)}
          parentClassName={`${selectedRepeatEvent?.value ? 'flex-1' : 'w-[50%]'}`}
          onChange={(val) => onHandleRepeatAppointment(val, values, setFieldValue, startDate)}
          name="repeat_event"
          isClearable={false}
          icon="repeat-filled"
          className="w-full"
          menuPortalTarget={document.body}
        />
        <div className="flex w-[50%] items-end gap-2">
          <Input
            data-qa="repeat-every"
            label="Repeat every"
            onChange={(e) => {
              const positive = Math.floor(Math.abs(e.target?.value)) || 1;
              setFieldValue('repeat_every', positive);
              if (positive > 1 && selectedRepeatEvent?.name === 'Day') {
                setFieldValue('weekdays', []);
              } else if (selectedRepeatEvent?.name === 'Day') {
                setFieldValue('weekdays', weekdays);
              }
            }}
            value={values.repeat_every}
            name="repeat_every"
            type="number"
            min={1}
          />
          <Input value={selectedRepeatEvent?.name} disabled className="w-[100px]" />
        </div>
      </div>

      <div className="flex flex-col gap-5">
        {((selectedRepeatEvent?.name === 'Day' && values.repeat_every === 1) ||
          selectedRepeatEvent?.name === 'Week') && (
          <div>
            <label className="m-0 flex text-sm font-500  text-neutral-800">Weekdays</label>
            <div className="mt-2 flex gap-2">
              {weekdays.map((weekday, i) => (
                <p
                  key={i}
                  onClick={() => handleSelectWeekday(weekday, selectedWeekdays, setFieldValue)}
                  className={`!hover:bg-primary-50$ flex h-[40px] flex-1 cursor-pointer items-center justify-center rounded-md shadow-sm ${
                    selectedWeekdays.map((item) => item?.value).includes(weekday?.value)
                      ? 'bg-primary-500 text-white'
                      : 'bg-neutral-100 text-neutral-800'
                  }`}>
                  {weekday.label}
                </p>
              ))}
            </div>
          </div>
        )}
        {['Month', 'Year'].includes(selectedRepeatEvent?.name) && (
          <div className="mt-2 ">
            <label className="mb-2 flex font-500">Repeat on</label>
            <div className="flex items-center gap-4">
              <RadioButton
                id="day-input"
                value={values?.repeat_on}
                label={`Day ${moment(startDate).get('D')}`}
                isSelected={values?.repeat_on === 'day'}
                onClick={() => handleChangeRepeatOn('day')}
                data-qa="login-email-radio"
                className="text-neutral-900"
                wrapperClassName="w-max"
              />
              <RadioButton
                id="week-input"
                value={values?.repeat_on}
                label={`On the ${getWeekOfMonth(startDate)} ${moment(startDate).format('dddd')} ${
                  selectedRepeatEvent?.name === 'Year'
                    ? 'of ' + moment(startDate).format('MMMM')
                    : ''
                }`}
                isSelected={values?.repeat_on === 'week'}
                onClick={() => handleChangeRepeatOn('week')}
                data-qa="login-email-radio"
                className="text-neutral-900"
                wrapperClassName="w-max"
              />
            </div>
          </div>
        )}
        <div className="flex items-end gap-4">
          <Select
            inputId="ends"
            label="Ends"
            value={values.ends_type}
            options={endsOptions}
            parentClassName={`${values?.ends_type?.value !== 'never' ? 'flex-1' : 'w-[50%]'}`}
            onChange={(val) => handleChangeEnds(val, startDate, setFieldValue)}
            isClearable={false}
            menuPortalTarget={document.body}
          />
          {values?.ends_type?.value !== 'never' && (
            <>
              {values.ends_type?.value === 'on_date' ? (
                <DatePicker
                  label="On Date"
                  onChange={(date) => handleChangeEndOnDate(date)}
                  value={values.end_date || startDate}
                  isClearable={false}
                />
              ) : (
                <Input
                  label="Appointments"
                  className="flex-1"
                  onChange={(e) => {
                    const positive = Math.floor(Math.abs(e.target?.value)) || 1;
                    setFieldValue('events', positive);
                  }}
                  value={values.events}
                  name="events"
                  type="number"
                  min={1}
                  onBlur={formik.handleBlur}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentRecurrence;
